module.exports = __webpack_public_path__ + "assets/images/close-circle.ed0a25d0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@int/signature/assets/images/close-circle.svg
// module id = 2118
// module chunks = 0